import createAPI from '@/common/createApi.js'
/**
 * config: 接口参数，
 * vconfig: （自定义参数）{
 *  neverLoading: 是否显示loading
 * }
 */
export default {
  // 获取access-token接口s
  potProtocolToken: (enterpriseId, config) => createAPI(`/auth/realms/${enterpriseId}/protocol/openid-connect/token`, 'post', config),
  // 管理员重置用户密码
  postAuthAdminRealmsResetPassword: (id, config) => createAPI(`/auth/admin/realms/${id}/users/${id}-manager/reset-password`, 'put', config),
  // portal获取账户信息
  getPortalAccountInfo: (realmName, username, config) => createAPI(`/idaas/admin/realms/${realmName}/users/${username}/info`, "get", config)
}